import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import LoadingSpinner from "../components/Loader/LoadingSpinner";
import ROUTES from "./Routes";

const ProtectedRoute = ({ children }) => {
 const isAuthenticated = !!localStorage?.userPhoneNumber;
 const hasPortrait = !!localStorage?.potrait_s3_url;
 // Biometric-consent gate: prevents deep-linking past the signing step.
 // The flag is set once consent is confirmed (in Login). If it's missing we bounce to
 // /login, which re-checks server-side and either sets the flag or shows the signing modal.
 const hasConsent = !!localStorage?.webConsentSigned;

 let location = useLocation();

 if (!isAuthenticated) {
  return <Navigate to="/login" state={{ from: location }} replace />;
}

 if (!hasPortrait) {
  return <Navigate to="/login" state={{ from: location }} replace />;
}

 if (!hasConsent) {
  return <Navigate to="/login" state={{ from: location }} replace />;
}

return children;
};

function RenderRoutes({ isLoading = false }) {
  return (
    <>
      {isLoading ? (
        <div>
          <LoadingSpinner />
        </div>
      ) : (
        <Routes>
          {ROUTES.map((route, i) => {
            const RouteComponent = route.component;
            if (typeof RouteComponent !== "function") {
              return null;
            }

            return (
              <Route
                key={i}
                path={route.path}
                exact={route.exact}
                element={
                  route.protected ? (
                    <ProtectedRoute>
                      <RouteComponent />
                    </ProtectedRoute>
                  ) : (
                    <RouteComponent />
                  )
                }
              />
            );
          })}
        </Routes>
      )}
    </>
  );
}

export default RenderRoutes;
// export default {Routes :RenderRoutes};
